var Hack = {
  ASTERISK: 'asterisk',
  BANG: 'bang',
  BACKSLASH: 'backslash',
  UNDERSCORE: 'underscore'
};

module.exports = Hack;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/lib/optimizer/hack.js
// module id = 156
// module chunks = 0 1